import { AsyncPipe } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatDivider } from '@angular/material/divider'
import { AuthService, Principal, PrincipalService } from '@elderbyte/ngx-auth'
import {
  ElderAppHeaderComponent,
  ElderExpandToggleButtonComponent,
  ElderNavLinkComponent,
  ElderNavListComponent,
  ElderShellComponent,
  ElderShellSideLeftDirective,
  ElderTogglePanelComponent,
  ElderTogglePanelPrimaryDirective,
  ElderTogglePanelSecondaryDirective,
  ElderTogglePanelTriggerDirective,
  ElderShellStaticNavSlotDirective,
  ElderRailNavDirective,
  ElderAppearanceSettingsComponent,
  ElderTranslatePipe,
} from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { FacilityContextService } from '../domain/context/facility-context/facility-context.service'
import { MainNavMenuComponent } from './main-nav-menu/main-nav-menu.component'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ElderShellComponent,
    ElderShellSideLeftDirective,
    ElderAppHeaderComponent,
    ElderExpandToggleButtonComponent,
    ElderTogglePanelTriggerDirective,
    ElderTogglePanelComponent,
    ElderTogglePanelPrimaryDirective,
    ElderNavListComponent,
    ElderNavLinkComponent,
    MatDivider,
    ElderTogglePanelSecondaryDirective,
    AsyncPipe,
    MainNavMenuComponent,
    ElderShellStaticNavSlotDirective,
    ElderRailNavDirective,
    ElderAppearanceSettingsComponent,
    ElderTranslatePipe,
  ],
})
export class AppComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly version = environment.version
  public readonly storageManagementUrl$: Observable<string>
  private principalService = inject(PrincipalService)
  private authService = inject(AuthService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const facilityContextService = inject(FacilityContextService)
  }

  /***************************************************************************
   *                                                                         *
   * Account                                                                 *
   *                                                                         *
   **************************************************************************/

  public get accountUrl(): string {
    return environment.issuerUrl + '/account'
  }

  public get principal$(): Observable<Principal> {
    return this.principalService.principalObservable
  }

  public logout(): void {
    this.authService.logout()
  }

  isOwner(principal: Principal | null) {
    return principal?.hasRole('OWNER')
  }
}
